<template>
  <b-form-group :label="label"
                :invalid-feedback="errorTxt"
                :state="state">
    <b-input-group :prepend="$t('department')">
      <b-form-select
          v-model="inputVal"
          :options="options"
          :state="state"
          :disabled="disabled">
      </b-form-select>
    </b-input-group>
  </b-form-group>
</template>

<script>
export default {
  props: {
    model: Object,
    label: String,
    attribute: {type: String, default: 'department'},
    errors: Array,
    disabled: Boolean
  },
  data() {
    return {
      inputVal: this.model[this.attribute] ? this.model[this.attribute] : null,
      state: null,
      errorTxt: '',
      options: [],
      country: null
    }
  },
  watch: {
    model: {
      handler(val) {
        this.state = null;
        this.errorTxt = '';
        this.inputVal = val[this.attribute];
      }, deep: true
    },
    inputVal(val) {
      this.state = null;
      this.errorTxt = '';
      this.model[this.attribute] = val;
    },
    errors(val) {
      let hasErr = false;
      if (val.length) {
        val.forEach(v => {
          if (v.param === this.attribute) {
            this.state = false;
            this.errorTxt = v.msg;
            hasErr = true;
            return;
          }
        });
      }
      this.state = !hasErr;
    }
  },
  methods: {
    load: function () {
      this.options = [
        {value: null, text: this.$t('selectDepartment')}
      ];
      this.$bgService.get('/department', {
        params: {
          page: 1,
          pageSize: 1000,
          status: '0'
        }
      }).then(response => {
        response.data.docs.forEach(item => {
          this.options.push({value: item._id, text: item.name});
        });
      });
    }
  },
  mounted() {
    this.load();
  },
  i18n: {
    messages: {
      en: {
        selectDepartment: 'Select department',
        department: 'Department'
      },
      vi: {
        selectDepartment: 'Chọn phòng kinh doanh',
        department: 'Phòng kinh doanh'
      }
    }
  }
}
</script>